import React ,{Component} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import pdflogo from './images/pdflogo.jpg';
import Serverurl from './Apiurl';
import Collapse from '@mui/material/Collapse';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio, { RadioProps } from '@mui/material/Radio';
import LocationBox from "./Locationpop";
import { Map, GoogleApiWrapper, Marker,InfoWindow  } from 'google-maps-react';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import classelect from './images/tick.jpg';
import clssblock from './images/cancel.jpg';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Paper from '@mui/material/Paper'; 
import Table from '@mui/material/Table'; 
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from '@mui/styles'; 
import MyLocationIcon from '@mui/icons-material/MyLocation';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
let strCust=[{title:'',year:0}];
const strProduct=[];
const strProductdeflt='';
const mapStyles = {
  width: '100%',
  height: '400px'
};const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});
 
export default class AdminBilling extends Component {
	constructor(props) {
    super(props);
	 var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	 this.state = {redirect:false,pagename:'',classtype:"1",subscribeData:[],slotcalData:[],errormessage:"",alerttype:"error",classtype:"1",subid:0,errorpen:false,startdate:'',startdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),price:0,latitude:"", longitude:'',gstpercentage:0,zoom:10,or_address:"",noofdays:'0',customerrauto:[], custid:'',selectedcustomerexchange:[],custarray:[],slotid:'',brid:'',slotData:[],btndisabled:false,btnsubmitext:'Submit',or_cu_id:'',paymenttype:2,actualdate:'',
	 sb_extramt:'',or_extramt:'',or_isenablebranch: '',orname:'',oremail:'',orphone:'',ortype:false,istraial:'1',isPaneOpenRight:false,dayscnt:0,pvdata:[],newpcid:"-1",showField:'',produserarray:[],productselectdval:[],productselectdtags:'',selectedproduct:0,editclick:0,prodprice:0,Branchdata:[],brlabel:'Select Branch',biladrs:'',selectslot:[],ordgst:0,subtotal:0,grandtotal:0,orddiscount:0,ordclsdiscount:0,
	  markers: [
        {
          title: "The marker`s title will appear as a tooltip.",
          name: "SOMA",
          position: { lat: 	12.971599, lng: 77.594566 }
        }
      ]}
	    this.onTagscustomerexchange = this.onTagscustomerexchange.bind(this);
		  this.onTagsproductChange = this.onTagsproductChange.bind(this);
	 }
	 
	 
getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
componentWillMount() { 

	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }else{

		
		this.onloadgetdate();
	}
			
}
onloadgetdate()
{ 
	axios.post(Serverurl+'ajaxsubscription.php?action=getdate')
	.then(resp => { 
		if(resp.data!==""){
			var str=resp.data;
					 var month="";
			var date1 = new Date(str);

			 if((date1.getMonth() + 1)<10)
			 {
				month="0"+ (date1.getMonth() + 1)		 
			 }else{month=(date1.getMonth() + 1)}  
			 this.setState({startdate:str,actualdate:str,startdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()});
		}
		let search = window.location.href;
		let ldimd = this.getParameterByName('ldid',search);
		
		let Orderid = this.getParameterByName('orid',search);
		if(ldimd!==null && this.state.or_cu_id==='')
		{  
			this.handleCustomerPop();
		}
		if(Orderid!==null )
		{  
			this.ApigetOrderbyid(Orderid);
		}
		else{
			this.onloadsubscribeBind();
		}
	});
	
}
ApigetOrderbyid(Orderid){
	axios.post(Serverurl+'ajaxorders.php?action=list&or_id='+Orderid)
  .then(resp => {  
		
    if(resp.data.length>0){ 
	
this.setState({
classtype:resp.data[0]["or_classtype"],	or_cu_id:resp.data[0]["or_cu_id"],	subid:resp.data[0]["or_sb_id"],
},()=>{this.onloadsubscribeBind();
this.onchangeSessiongetprice(this.state.subid);

this.onloaduserbyid(resp.data[0]["or_cu_id"]);
});	
	}
  
    });
	
}
onloadsubscribeBind(){
  
	axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_type='+this.state.classtype)
	.then(resp => {  
		
	    if(resp.data.length>0){	

let atrsubscribe=resp.data;

	
				const filteredData = [];
				
				for (let i = 0; i < atrsubscribe.length; i++) {
   if(atrsubscribe[i].sb_id!="11" &&  atrsubscribe[i].sb_id!="12" &&  atrsubscribe[i].sb_id!="14" &&  atrsubscribe[i].sb_id!="15" ){
        filteredData.push(atrsubscribe[i]);
    }
}

			this.setState({subscribeData:filteredData},()=>{
				
				
				
				
				let subscribeFromApi = this.state.subscribeData.map(row => {
                      
					return {value:row.sb_id,display:row.sb_title}
					  
				});
      
		            this.setState({
						 subscribeData: [{value: '0', display:'Select Duration'}].concat(subscribeFromApi)},()=>{});
								
			})
	
				if(this.state.classtype!=="1" )
				{
					this.onloadBranch();	
				}else if(this.state.ortype===true){
						this.onloadslot();	
				}								
		}else{
				this.setState({subscribeData:[]});
		}

    });

}	
	
	onloadslot(){
		
		axios.post(Serverurl+'ajaxslotmanagement.php?action=getall&sm_bm_id='+this.state.brid+'&sm_slottype='+this.state.classtype+'&sorting=sm_order')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						slotData:resp.data	
							},()=>{
								
							console.log(this.state.slotData)	
								 let slotApi = this.state.slotData.map(row => {
                          
          return {value:row.sm_id,display:row.sm_slotname}
        });
      
		
        this.setState({
          slotData: [{value: '0', display:'Select Slot'}].concat(slotApi)
        });
								
							})


				
			
  }else{
	  this.setState({slotData:[]});
  }
    });
		
	}
		myChangeHandler = (event) => {
			
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val,curentslot:""},()=>{
	  
	  if(nam=="subid")
	  {
		  this.onchangeSessiongetprice(this.state.subid)
				  
	  }
	   if(nam==="brid")
	  {
		  localStorage.setItem("AYLbrid",val)
		 	if((this.state.classtype==="6" || this.state.classtype==="1" || this.state.classtype==="2") && this.state.brid!=="")
							{
							this.onloadslotcalendar();
							}
							
							
							if(this.state.ortype===true)
							{
								if( this.state.classtype==="2" || this.state.classtype==="4" || this.state.classtype==="6")
								{
								
									this.onloadslot();	
								}
							}else{
							if( this.state.classtype==="3" || this.state.classtype==="4" || this.state.classtype==="7")
							{
							
this.onloadslot();	
							}	
							}
							
				  
	  }if(nam==="orddiscount")
	  {
		  this.Taxcalculactionbind();
	  }
	   
	  
	  
  });
 
}
onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid=this.state.brid;

								if(resp.data.length===1 && strbrid!='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({brid:strbrid,
          Branchdata: [{value: '0', display:'Select Branch'}].concat(BranchFromApi)
        },()=>{
			if( this.state.classtype==="3" || this.state.classtype==="4" || this.state.classtype==="7")
							{
					
this.onloadslot();	
							}
			
			
		});
								
							})


							
  }else{
	  this.setState({Branchdata:[]});
  }
  });
	
}
/*onchangeSessiongetprice(subid)
{
	  axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_id='+this.state.subid)
		  .then(resp => {  
				
		  if(resp.data.length>0){
						
				this.setState({price:resp.data[0]["sb_amount"],gstpercentage:resp.data[0]["sb_gstpercentage"],noofdays:resp.data[0]["sb_noofdays"]},()=>{
							if((this.state.classtype==="6" || this.state.classtype==="1" || this.state.classtype==="2") && localStorage.getItem("AYLbrid")!==null)
							{
							this.onloadslotcalendar();
							}
							if( this.state.classtype==="3" || this.state.classtype==="4" || this.state.classtype==="7")
							{
							
this.onloadslot();	
							}
							
							});
		  }
		  })
}
*/
onchangeSessiongetprice(subid) {
  axios.post(Serverurl + 'ajaxsubscription.php?action=getall&sb_id=' + subid)
    .then(resp => {
      if (resp.data.length > 0) {
        this.setState({
          price: resp.data[0]["sb_amount"],
          gstpercentage: resp.data[0]["sb_gstpercentage"],
          noofdays: resp.data[0]["sb_noofdays"],
          or_extramt: resp.data[0]["sb_extramt"]
        }, () => {
          if ((this.state.classtype === "6" || this.state.classtype === "1" || this.state.classtype === "2") && localStorage.getItem("AYLbrid") !== null) {
            this.onloadslotcalendar();
          }
          if (this.state.classtype === "3" || this.state.classtype === "4" || this.state.classtype === "7") {
            this.onloadslot();
          }
        });
      }
    });
}


	  handleErrorclose=(event)=>{
	  
	this.setState({errorpen: false});  
  }
onloadslotcalendar(){
		
		axios.post(Serverurl+'ajaxslotbookings.php?action=book&sm_bm_id='+localStorage.getItem("AYLbrid")+'&sm_slottype='+this.state.classtype+'&startdate='+this.state.startdate1+'&days='+this.state.noofdays)
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						slotcalData:resp.data	,dayscnt:0,selectslot:[],
							}) 
			}else{
				this.setState({slotcalData:[]});
			}
 
    });
		
	}
	handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ startdate:dayjs(date),
startdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 },()=>{this.onloadslotcalendar();})
	
	
  }
  onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	 var d = new Date(this.state.actualdate);
	 if(event.target.value==="3" || event.target.value==="4" || this.state.classtype==="7")
	 {
 d.setDate(d.getDate() - 5);
	 }
 var month="";
 if((d.getMonth() + 1)<10)
	 {
		month="0"+ (d.getMonth() + 1)		 
	 }else{month=(d.getMonth() + 1)} 
		 this.setState({startdate:dayjs(d),subid:0,brid:'',or_address:'',classtype: event.target.value},()=>{
			 
			 if(event.target.value!="5")
			 {
			 this.onloadsubscribeBind();
			 }
			 else{
			 this.setState({ 
	 pvdata: [{"op_id":this.state.newpcid,"title":"","prid":"","price":"","gst":"","qty":"","discount":"0","amount":"0","isdeleted":0,"oldtitle":"","oldprid":"","oldprice":"","oldgst":"","oldqty":"","oldamount":"0","olddiscount":"0",}],showField: this.state.newpcid ,});
				
			}
		 });
	}
	
	handlebookChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ ortype: event.target.checked},()=>{
		if(event.target.checked===true)
		{
		//
		 this.setState({ istraial: ""},()=>{this.onloadsubscribeBind();});
		}else{
			this.setState({ istraial: "1"},()=>{this.onloadsubscribeBind();});
		}
		
		
	});
  };
  
onloadCustomerexchangeBind=(event)=>{
	if(event.target.value.length>2 )
	{
		axios.get(Serverurl+'ajaxcustomer.php?action=autoextender&cu_name='+event.target.value).then(resp => { 
		this.setState({ custarray:resp.data,customerrauto:[]});

			var rowsArray = this.state.custarray;
			rowsArray.map((row, i) => {			 
				let j=(i+1);			
				const items = {
					title:row.title,
					year:row.year,
					cu_emailid:row.cu_emailid,
					cu_phoneno:row.cu_phoneno,
					rowindex:j,			 
				};
				
				  const found = strCust.some(el => el.year === row.year);
		 if (!found) strCust.push(items);
		
			  
			});
		 
		this.setState({customerrauto:strCust},()=>{console.log(this.state.customerrauto)})
		}); 
	}
}

onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({custid:newTextValue})
	} 
}
onTagscustomerexchange = (event, values) => {
	if(values!==" " && values!==null){
		this.setState({
		custid:values.year,
		or_cu_id:values.year,
		selectedcustomerexchange:values},()=>{})
	}
	else
	{
		 this.setState({ custid:'',or_cu_id:'',selectedcustomerexchange:[]})
	}
}
	 
handleCustomerPop()
{
	this.refs.Customerbox.handleClickOpen() 
}

handlecustomerback = (childData) => {
	this.setState({ custid:childData});		  
	this.onloaduserbyid(childData);
}
	 
onloaduserbyid(cuid){		
	axios.get(Serverurl+'ajaxcustomer.php?action=getall&cu_id='+cuid)
	.then(resp => {  
		if(resp.data.length>0){
			const items = {
				title:resp.data[0]["cu_name"],
				year:resp.data[0]["cu_id"],
				cu_emailid:resp.data[0].cu_emailid,
				cu_phoneno:resp.data[0].cu_phoneno,
				rowindex:1,
			};
		   
			this.setState({custid:resp.data[0].cu_id,selectedcustomerexchange: items,
			orname:resp.data[0]["cu_name"],oremail:resp.data[0]["cu_emailid"],orphone:resp.data[0]["cu_phoneno"],});
		}
    });
} 
handleCalllocation = (childData) => {
    var strvalues1=childData.split('~');
	localStorage.setItem("AYLbrid",strvalues1[3])
    this.setState({ sellat:strvalues1[0],sellong:strvalues1[1],latitude:strvalues1[0],longitude:strvalues1[1],or_address:strvalues1[2],brid:strvalues1[3],isPaneOpenRight:false },()=>{
					if((this.state.classtype==="1" || this.state.classtype==="2") && this.state.brid!=="")
					{
						this.onloadslotcalendar();
					}
			
				});
    };
handlepanleClose= (e) =>{		
    this.setState({ isPaneOpenRight:false});
}
Categoryaddbox= (event) =>{      
    this.setState({ isPaneOpenRight:true});
}
 

OnclickSubscribe=(event)=>{
	 event.preventDefault();
	
	 var self=this;
	 let classtype = this.state.classtype;
let subid = this.state.subid;
let slotid = this.state.slotid;
let startdate1 = this.state.startdate1;
let price = this.state.price;
let noofdays = this.state.noofdays;
let brid = this.state.brid;
let biladrs = this.state.biladrs;
let day1 = this.state.day1;

let day1slot = this.state.day1slot;
let day2 = this.state.day2;

let day2slot = this.state.day2slot;
let day3 = this.state.day3;

let day3slot = this.state.day3slot;
 var slotArray = this.state.slotcalData;
  var or_address = this.state.or_address;
 
 let prodprice = this.state.prodprice;
 var paymenttype = this.state.paymenttype;
  var gstpercentage = this.state.gstpercentage;
   let dayscnt = this.state.dayscnt
let strsubdata = "",strsubuser="",strweek="",strsep="",strslotidsel="";


if(this.state.istraial==="1"){
	
	if(this.state.classtype!=="5"){
 
 var subnewRow = slotArray.map((rowssub, j) => { 


if(rowssub.ismonday=="1")
{
	strweek="Monday";
	strslotidsel=rowssub.sm_id;
}
if(rowssub.istuesday=="1")
{if(strweek!="")
	{
	strsep=",";
	}
	strweek=strweek+strsep+"Tuesday";
	strslotidsel=strslotidsel+strsep+rowssub.sm_id;
}
if(rowssub.iswednesday=="1")
{  if(strweek!="")
	{
	strsep=",";
	}
	strweek=strweek+strsep+"Wednesday";
	strslotidsel=strslotidsel+strsep+rowssub.sm_id;
}
if(rowssub.isthursday=="1")
{if(strweek!="")
	{
	strsep=",";
	}
	strweek=strweek+strsep+"Thursday";
	strslotidsel=strslotidsel+strsep+rowssub.sm_id;
}
if(rowssub.isfriday=="1")
{if(strweek!="")
	{
	strsep=",";
	}
	strweek=strweek+strsep+"Friday";
	strslotidsel=strslotidsel+strsep+rowssub.sm_id;
}
if(rowssub.issaturday=="1")
{if(strweek!="")
	{
	strsep=",";
	}
	strweek=strweek+strsep+"Saturday";
	strslotidsel=strslotidsel+strsep+rowssub.sm_id;
}

if(rowssub.issunday=="1")
{if(strweek!="")
	{
	strsep=",";
	}
	strweek=strweek+strsep+"Sunday";
	strslotidsel=strslotidsel+strsep+rowssub.sm_id;
}	 
strsubdata=strweek;

strsubuser="=;";

 })
	}	
	
	if(this.state.classtype==="5"){
		strsubdata = "";
		strsep="";let index=0;subid=0;
		let optionsVal = this.state.pvdata;
		var srearray=optionsVal.filter(value => value.op_isdeleted  < 1)
		if(srearray.length-1 === 0)	
{
	 this.setState({errormessage:"Please Select Product ",open:true,btndisabled:false,submitbtn:"Submit"});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
			
		 if(optionsVal.length === 1)
	 {
		
		 this.setState({errormessage:"Please Select Product ",open:true,btndisabled:false,submitbtn:"Submit"});
		 window.scrollTo({
          top: 0
      })
		 return false;
	 }
		optionsVal.forEach(eachval => {
     
		   if(index!=0)
		   {
	   if(eachval.op_id<0 && eachval.op_isdeleted===1)
	   {
		   
	   }
	   else
	   {
		    
 strsubdata=strsubdata+strsep+eachval.prid+"~"+eachval.title+"~"+eachval.price+"~"+eachval.qty+"~"+eachval.gst;
 strsep=";"; 
	   }
		   
		   }
		   index=1;
		   
	 
    })
	}
}
 if(this.state.or_cu_id===''){
						
		this.setState({errormessage:"Please Enter Select Customer.",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
				
				if(this.state.classtype!=="5" && this.state.ortype===false){
	if(subid===0 || subid==="" || subid==="0"){
						
		this.setState({errormessage:"Please Enter Select Duration.",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
				}
				if(startdate1===0){
						
		this.setState({errormessage:"Please Select Start Date.",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
				
				
				if(classtype==="1" )
	
	{	
if(or_address===""){	
this.setState({errormessage:"Please Select Location",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false;
}	
	}
	
	if(this.state.ortype===false && classtype!="5")
	{

		if( classtype==="4" || classtype==="7")
	{		
				if(slotid===0 || slotid===""){
								
				this.setState({errormessage:"Please Select Slot.",errorpen:true});
				 window.scrollTo({        top: 0     })
			return false; 
					
						}
	}
	
	else if( classtype==="1" || classtype==="2" || classtype==="6"){
		
		if(strslotidsel===""){
						
		this.setState({errormessage:"Please Select  Slots",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}			
		}
		
			
		

	}
	if(paymenttype==="" || paymenttype==="0"){
						
		this.setState({errormessage:"Please Select Mode of Payment.",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
if(this.state.ortype===true && this.state.classtype!=="3")
	{
if(day1==="0"){
						
		this.setState({errormessage:"Please Select Day",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
				 
 if(day1slot==="0"){
						
		this.setState({errormessage:"Please Select Slot",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
				 if(day2==="0"){
						
		this.setState({errormessage:"Please Select Day",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				} if(day2slot==="0"){
						
		this.setState({errormessage:"Please Select Slot",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				} if(day3==="0"){
						
		this.setState({errormessage:"Please Select Day",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				} if(day3slot==="0"){
						
		this.setState({errormessage:"Please Select Slot",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}
strsubdata=day1+"~"+day1slot+";"+day2+"~"+day2slot+";"+day3+"~"+day3slot;
}
if(biladrs===""){
						
		this.setState({errormessage:"Please Enter Billing Address.",errorpen:true});
		 window.scrollTo({        top: 0     })
	return false; 
			
				}

	this.setState({btnsubmitext:"Processing...",btndisabled:true});			
	var formData = new FormData();
	
	formData.append('action','insertupdate')

	formData.append('or_id',"0")
	formData.append('orderby',strsubdata)
	formData.append('or_classtype',classtype)
	
	if(this.state.ortype===true)
	{
	if(classtype==="1")
	{
	formData.append('or_sb_id',"11")
	}
	else if(classtype==="2")
	{
	formData.append('or_sb_id',"12")
	}
	else if(classtype==="3")
	{
	formData.append('or_sb_id',"13")
	}
	else if(classtype==="4")
	{
	formData.append('or_sb_id',"14")
	}
	else if(classtype==="6")
	{
	formData.append('or_sb_id',"15")
	}
	}
	else{
		formData.append('or_sb_id',subid)
		
	}
	
	formData.append('or_startdate',startdate1)
		formData.append('or_latitude',this.state.latitude)
	formData.append('or_longitude',this.state.longitude)
	formData.append('or_address',or_address)
	if( classtype==="4" || classtype==="7")
	{
	formData.append('slotid',slotid)
	}
	else if(classtype==="5")
	{
	formData.append('slotid',0)
	}
	else{
		formData.append('slotid',0)
	}
	formData.append('or_calslot',strslotidsel)
	
	formData.append('noofdays',noofdays)
	if(classtype!=="5")
	{
	formData.append('total',price)
	}
	else{
		formData.append('total',this.state.grandtotal)
	}
	formData.append('or_billingaddress',biladrs)
	
	
	if(classtype==="1")
	{
		formData.append('or_bm_id',brid)
	}else{
	formData.append('or_bm_id',localStorage.getItem("AYLbrid"))
	}
	formData.append('or_gstpercentage',gstpercentage)
	if(this.state.ortype===true)
	{
	formData.append('or_booktype',2)
	}else{
				if(classtype==="7")
			{
				formData.append('or_booktype',3)
			}else{
				formData.append('or_booktype',1)
			}
	}
	formData.append('or_ismanual',"1")
	if(subid!=0)
	{
	formData.append('or_discount',this.state.ordclsdiscount)
	}
	else{
	formData.append('or_discount',this.state.orddiscount)
	}
	formData.append('or_message',"")
	formData.append('or_paymenttype',paymenttype)
	formData.append('or_cu_id',this.state.or_cu_id)
	
	/*formData.append('or_isenablebranch', this.state.or_isenablebranch === true ? 1 : 0);
	formData.append('or_extramt', this.state.or_extramt || 0);*/
	
	formData.append('or_isenablebranch', this.state.or_isenablebranch === true ? 1 : 0);
	formData.append('or_extramt', this.state.or_isenablebranch ? this.state.or_extramt || 0 : 0);
	axios.post(Serverurl+"ajaxorders.php", formData, {
				}).then(res => {
					
					var strresult=res.data.trim();
						strresult=strresult.split('~');
						
						if(strresult[0]!=="0")
					{
						
	
		
	this.setState({btndisabled:false,pvdata:[],btnsubmitext:"Submit",errorpen:false,errormessage:'Your booking has been created',redirect:true,pagename:'/Orderdetails?orid='+strresult[0],ortype:false,istraial:"1"});
	
					}else{
						this.setState({btnsubmitext:"Next",btndisabled:false,errorpen:true,errormessage:'Maximum persons exceeded, please try with different start date and preference'});	
					}
					
					
				});
	
	
	}
	
	handleAbsent = (id,rowsd,type,isseltype) => {
	  
	 /* if(this.state.curentslot!=="")
	  {
		if(this.state.curentslot!==id && isseltype===1)
	  {
this.setState({errormessage:"Please select same slot for all days",errorpen:true});
	 window.scrollTo({        top: 0     });
	 	return false;
	  }		  
	  }*/
	  let strslotid=id;
const updatedArray = [...this.state.slotcalData];
let strcount=this.state.dayscnt,noofdays=parseFloat(this.state.noofdays),strcntval="6";;
let strcount1= parseFloat(this.state.dayscnt);
if(noofdays<6)
{
	strcntval=noofdays
}

if(isseltype!==1)
{
	strcount1=0;
}
if(strcount1>=strcntval)

{
	
	this.setState({errormessage:"You can select only "+ (parseFloat(strcntval))+" days in a week",errorpen:true});
	 window.scrollTo({        top: 0     })
	return false;

}else if(strcount1<strcntval){

if(localStorage.getItem("AYLrole")!=="1")
{

if(type===1 || type===3 || type===5)
{
	
if(updatedArray[rowsd].ismonday==="1")
	{
updatedArray[rowsd].ismonday = "0" ;
		updatedArray[rowsd].isselect = "0" ;
		
		strcount=parseInt(strcount)-1;
updatedArray[rowsd].iswednesday = "0" ;
		updatedArray[rowsd].isselect = "0" ;
			strcount=parseInt(strcount)-1; 
updatedArray[rowsd].isfriday = "0" ;
		updatedArray[rowsd].isselect = "0" ;
			 strcount=parseInt(strcount)-1;
			 strslotid="";
}
else{
updatedArray[rowsd].ismonday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
		
		strcount=parseInt(strcount)+1;
updatedArray[rowsd].iswednesday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
			strcount=parseInt(strcount)+1; 
updatedArray[rowsd].isfriday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
			 strcount=parseInt(strcount)+1;
}	
}
else if(type===2 || type===4 || type===6)
{
	
	if(updatedArray[rowsd].istuesday==="1")
	{
		updatedArray[rowsd].istuesday = "0" ;
		updatedArray[rowsd].isselect = "0" ;
		strcount=parseInt(strcount)-1;	
updatedArray[rowsd].isthursday = "0" ;
		updatedArray[rowsd].isselect = "0" ;
			strcount=parseInt(strcount)-1;
			
	updatedArray[rowsd].issaturday = "0" ;
			updatedArray[rowsd].isselect = "0" ;
		strcount=parseInt(strcount)-1; 
		strslotid="";
		
	}else{
updatedArray[rowsd].istuesday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
		strcount=parseInt(strcount)+1;	
updatedArray[rowsd].isthursday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
			strcount=parseInt(strcount)+1;
			
	updatedArray[rowsd].issaturday = "1" ;
			updatedArray[rowsd].isselect = "1" ;
		strcount=parseInt(strcount)+1; 	
	}		
}

}
if(localStorage.getItem("AYLrole")==="1")
{
	
	if(type===1)
{
	if(updatedArray[rowsd].ismonday==="0")
	{
		updatedArray[rowsd].ismonday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
		
		strcount=parseInt(strcount)+1;	  
	}
else{
	updatedArray[rowsd].ismonday = "0" ;
	strcount=parseInt(strcount)-1;
	updatedArray[rowsd].isselect = "0" ;
	
}
}
else if(type===2)
{
	if(updatedArray[rowsd].istuesday==="0")
	{
		updatedArray[rowsd].istuesday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
		strcount=parseInt(strcount)+1;	
	
	}
else{
	updatedArray[rowsd].istuesday = "0" ;
updatedArray[rowsd].isselect = "0" ;
	strcount=parseInt(strcount)-1;
	
}
}
else if(type===3)
{
	if(updatedArray[rowsd].iswednesday==="0")
	{
		updatedArray[rowsd].iswednesday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
			strcount=parseInt(strcount)+1; 
		
	}
else{
	updatedArray[rowsd].iswednesday = "0" ;
	updatedArray[rowsd].isselect = "0" ;
	strcount=parseInt(strcount)-1;
	
}
}
else if(type===4)
{
	if(updatedArray[rowsd].isthursday==="0")
	{
		updatedArray[rowsd].isthursday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
			strcount=parseInt(strcount)+1;
			
	}
else{
	updatedArray[rowsd].isthursday = "0" ;
	updatedArray[rowsd].isselect = "0" ;
	strcount=parseInt(strcount)-1;
	
}
}
else if(type===5)
{
	if(updatedArray[rowsd].isfriday==="0")
	{
		updatedArray[rowsd].isfriday = "1" ;
		updatedArray[rowsd].isselect = "1" ;
			 strcount=parseInt(strcount)+1;
			 
	}
else{
	updatedArray[rowsd].isfriday = "0" ;
	updatedArray[rowsd].isselect = "0" ;
	strcount=parseInt(strcount)-1; 
	
}
}
else if(type===6)
{
	if(updatedArray[rowsd].issaturday==="0")
	{
		updatedArray[rowsd].issaturday = "1" ;
			updatedArray[rowsd].isselect = "1" ;
		strcount=parseInt(strcount)+1; 
		
			  
	}
else{
	updatedArray[rowsd].issaturday = "0" ;
	updatedArray[rowsd].isselect = "0" ;
	strcount=parseInt(strcount)-1; 
	
}
}

	
}
if(strcount===0)
{
	strslotid="";
}

/*
var strrow=rowsd.toString(),arr=this.state.selectslot;
let strclasstype=[...this.state.selectslot,[strrow,id,type]]

if(Array.isArray(this.state.selectslot)){

	if(updatedArray[rowsd].isselect==="0")
	{
	for (var i = strclasstype.length - 1; i >= 0; --i) {           // while (i-- > 0) {
    if (strclasstype[i][1] == id && strclasstype[i][2] == type) {
		
        strclasstype.splice(i, 1);
    }
	}
	}
}*/

this.setState({curentslot:strslotid  ,slotcalData: updatedArray,dayscnt:strcount,errorpen:false	 });

}

 
  };
  myChangeHandlerPV = (firstrow) => event  => { 
  const re = /^[0-9.\b]+$/;
   let nam = event.target.name;
  let val = event.target.value;
  
    let id = this.state.showField;
	 let optionsRep = this.state.pvdata;
   var rowsArray = this.state.pvdata; 
   
    optionsRep.forEach(eachrep => {
		
			
		 
       if (eachrep.op_id === id)
	   {
		   
		   if(nam==="price")
		   {
			  eachrep.price=val ;
			  
			   eachrep.amount=parseFloat( eachrep.qty)*parseFloat(val);
		   }
		    if(nam==="qty")
		   {
			  eachrep.qty=val ;
			  
			   eachrep.amount=parseFloat(val)*parseFloat(eachrep.price);
		   }
		   
	   }
	   
	});
	this.setState({pvdata: optionsRep,})
  }
  
 onloadProductsBind=(event)=>{

	 if(event.target.value.length>2 ){
 axios.get(Serverurl+'ajaxsubscription.php?action=getall&sb_type=5&sb_title='+event.target.value)
  .then(resp => { 
  
  if(resp.data.length>0){
 
   this.setState({produserarray:[]})
  	 var rowsArrayp = resp.data;
	 rowsArrayp.map((row, j) => {
			 
		 const items = {
			 
        title:row.sb_title,
         year:row.sb_id,
		
		 price:row.sb_amount,
		gst:row.sb_gstpercentage,
		 
        };
     
		  strProduct.push(items);
		 });
		   this.setState({produserarray:strProduct})
  } 
  
  
  });
 
  }
}
   onInputprodChange = (event, newTextValue) => {

if(newTextValue!==" "){


  this.setState({productselectdtags:newTextValue})
}

  
 }  
 
 
 handleAllBranchChange = (event) => {
  this.setState({ or_isenablebranch: event.target.checked });
};
onTagsproductChange = (event, values) => {
	
	 let discal=0,stramt=0;
if(values!=null)
{
	 let id = this.state.showField;
	 let optionsRep = this.state.pvdata;
   optionsRep.sort((a, b) => a.op_id > b.op_id ? 1 : -1).forEach(eachrep => {
		
       if (eachrep.op_id === id)
	   {
		  eachrep.title= values["title"]; 
		   eachrep.price= values["price"]; 
		   eachrep.gst= values["gst"]; 
		   		   eachrep.prid= values["year"]; 
		   
eachrep.qty= "1"; 	
 eachrep.amount= values["price"];
stramt =values["price"];
	  }
	   
	  
    })
  
this.setState({pvdata: optionsRep, selectedproduct:values,prodprice:parseFloat(this.state.prodprice)+parseFloat( stramt)})
}else{
	this.setState({selectedproduct:[]});
}
}
fieldsave(id,strStatus){
	let discountsum=0, optionstax=[],r=false,strtotalqty=0,stramt=0;
	 let optionsRep = this.state.pvdata;
	if(strStatus=="2")
	{
		 r = window.confirm("Are you sure to Delete Product ?");
		//optionstax = this.state.taxdata;
	}
	optionsRep.sort((a, b) => a.op_id > b.op_id ? 1 : -1).forEach(eachrep => {
	 
	 
	 
	  if(r == true && strStatus=="2" ){
			 
			
       if (eachrep.op_id === id)
	   {eachrep.isdeleted = 1;
   stramt=parseFloat(this.state.prodprice)-parseFloat(eachrep.amount);
   eachrep.price = 0;eachrep.qty = 0;eachrep.amount = 0;

	   }
	  }
	  	else  if( strStatus=="1" ){
       if (eachrep.op_id === id)
	   {
		   eachrep.oldprid= eachrep.prid;
            eachrep.oldtitle = eachrep.title;	   
		   
 eachrep.oldprice = eachrep.price;
 eachrep.oldofferprice = eachrep.offerprice; 
  eachrep.oldqty = eachrep.qty;
     eachrep.oldgst = eachrep.gst;
    eachrep.oldamount = eachrep.amount; 
	stramt=eachrep.amount; 
	   }
		}
	});
	let vnewpcid=this.state.newpcid;
	if(strStatus=="1" ){
	
	
if(this.state.newpcid<0)
{
	if(this.state.editclick!==1)
	{
	  vnewpcid=this.state.newpcid-1;
	  
	let newrow={"op_id":vnewpcid,"title":"","price":"","gst":"","qty":"","amount":"0","discount":"0","isdeleted":0,"oldtitle":"","oldprice":"","oldgst":"","oldqty":"","oldamount":"0","olddiscount":"0",}
	   optionsRep.unshift(newrow);
	   
	
	}
}
	}
	
	this.setState({
	pvdata: optionsRep,prodprice:parseFloat(this.state.prodprice)+parseFloat( stramt) ,editclick:0,  newpcid:vnewpcid, showField: vnewpcid,editclick:0,},()=>{
		
		this.Taxcalculactionbind();
	});
}

fieldedit(id,pr_id){
	//alert(id)
	this.setState({showField:id,editclick:1,subtotal:0,showtaxField:id,withoutdissubtotal:0 })
	
	
	
}

Taxcalculactionbind	(){
	
	let optionstaxRep = this.state.pvdata;
	 	
//optionstaxRep=optionstaxRep.sort((a, b) =>{ a.tax > b.tax ? 1 : -1});
optionstaxRep  = [].concat(optionstaxRep).sort(function(a, b) {
    return a.gst > b.gst ? 1 : -1;
  })

		let previoustax="",strsubtotal=0,strcurnttax="",prerow=0,taxablevalue=0,rate="",totaltaxamt=0,taxamount=0,totalamount=0;
	let sumtax=0,strtotalqty=0, strgrantotal=0,strtotaldiscount=0;
	let taxarr=[];
		 
		   optionstaxRep.forEach(eachrep => {
		if(eachrep.gst!=""){
			  if(  eachrep.isdeleted !== 1){
			   strcurnttax=eachrep.gst;
			   
			
			strsubtotal=parseFloat(strsubtotal)+parseFloat(eachrep.amount)
			  if(strcurnttax!==previoustax && previoustax!=="")
			  {
				
				var item = { 
				  taxamount:taxablevalue,
				  cgstrate:rate,
				  cgstamt:taxamount,
				  sgstrate:rate,
				  sgstamt:taxamount,
				  totaoatax:totalamount.toFixed(2),
				}
				
				
				// taxarr.push(item)

taxablevalue=0;
				  rate="";
				  taxamount=0;
				  totalamount=0;

previoustax=eachrep.gst ;
  
			  } 
			  
			  
			 
			 let taxablveamtqty=(parseFloat(eachrep.amount))-parseFloat(eachrep.discount);
			
			//taxablveamtqty=((parseFloat(taxablveamtqty) * (100 / (100 + parseFloat(((eachrep.gst))) ))))*eachrep.qty;
			 
			  taxablevalue=Number(taxablevalue)+parseFloat(taxablveamtqty);
		//let strtax=parseFloat(eachrep.amount)-(parseFloat(eachrep.amount) * (100 / (100 + parseFloat(((eachrep.tax)/2)) )));
		
	let strtax=((parseFloat(taxablveamtqty )* Number(eachrep.gst))/100)/2;
	
			 previoustax=eachrep.gst ;
			  
				  rate=Number(eachrep.gst)/2;
taxamount=Number(taxamount)+ parseFloat(strtax);
	//totaltaxamt=Number(totaltaxamt)+ parseFloat(strtax);			  
				   totalamount=parseFloat(totalamount )+parseFloat(taxablveamtqty )+(parseFloat(strtax)*2);
			sumtax=Number(sumtax)+(parseFloat(strtax)*2);
					  
		 
		 } 
	}	
		 })

		 var item = { 
				  taxamount:taxablevalue,
				  cgstrate:rate,
				  cgstamt:taxamount,
				  sgstrate:rate,
				  sgstamt:taxamount,
				  totaoatax:totalamount.toFixed(2)
				}
				
				
				// taxarr.push(item)

taxablevalue=0;
				  rate="";
				  taxamount=0;
				  totalamount=0;
	//strgrantotal=Number(this.state.subtotal)-Number(this.state.ordtotaldiscount)+Number(sumtax.toFixed(2))-Number(this.state.roundoff)
	
	 strgrantotal=parseFloat(strsubtotal)-parseFloat(this.state.orddiscount)+parseFloat(sumtax.toFixed(2))

 this.setState({ordgst:sumtax.toFixed(2),subtotal:strsubtotal,grandtotal:strgrantotal.toFixed(2),  
 },()=>{
			
				
		
			
		});
		  
	  
}
	render() { 
  let stramount="0";
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
/*<TableCell>

{item.issunday==="0" && (
<CheckBoxOutlineBlankIcon onClick={()=>{this.handleAbsent(item.sm_id,index,7,1)}}/>
 
)}{item.issunday==="1" && (
<img src={classelect} width="20px" onClick={()=>{this.handleAbsent(item.sm_id,index,7,2)}}/>

)}
{item.issunday==="2" && (
<img src={clssblock} width="20px"/>
)}
</TableCell>
*/
  
  return (
 
		<React.Fragment>
		<div className="boxheading">
				
<h2> Manual Billing </h2>
</div>
		
<div className="clear"></div>
		<div className="billingform">
		<div className="formbox">
  <p>  <Collapse in={this.state.errorpen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
	 
<div className="formpadd">

 <Customerbox ref="Customerbox" parentCallback={this.handlecustomerback}/>
 <p>
 <Switch
      checked={this.state.ortype}
      onChange={this.handlebookChange}
      inputProps={{ 'aria-label': 'controlled' }}
    />Trial Class</p>
<p>Customer  
<span className="textright"  onClick={()=>{this.handleCustomerPop()}} >+New Customer</span>
</p>
	<p>

<Autocomplete
      id="free-solo-demo"
      
      className="txtbox"  inputValue={this.state.custid}
      options={this.state.customerrauto}   onInputChange={this.onInputCustChange}
	   onChange={this.onTagscustomerexchange} 
	    value={this.state.selectedcustomerexchange}
      renderInput={(params) => (
        <TextField {...params} className="txtbox" onChange={this.onloadCustomerexchangeBind}  variant="outlined" />
      )}
 getOptionLabel={(option) => option.title || ""}

      renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody>
              <tr {...props}>
                <td width='10%'>{option.title}</td>
                <td width='10%'>{option.cu_emailid}</td>
				
                <td width='10%'>{option.cu_phoneno}</td>
				
              </tr>
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
</p>
	 <SlidingPane
	className="registerpane"
        closeIcon={<div className="closeIcon" onClick={this.handlepanleClose}>X</div>}
        isOpen={this.state.isPaneOpenRight}
        title=""
        from="right"
        width="100%"
        onRequestClose={() => this.setState({ isPaneOpenRight: false })}
      >
        <div> <LocationBox ref="Locationbox" custid={this.state.or_cu_id} parentcallAddress={this.handleCalllocation}  />
		

		</div>
      </SlidingPane>
<ul className="manualsubscribed">

<li>
<p>Select Your Preference</p>
<FormControl className="preference">
  
      <RadioGroup  value={this.state.classtype}
        defaultValue={this.state.classtype}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"   onChange={this.onChangeClass}
      >
        <FormControlLabel value="1" control={<Radio />} label="Personal Training at Home" />
        <FormControlLabel value="2" control={<Radio />} label="Personal Training in Studio" />
        <FormControlLabel value="3" control={<Radio />} label="Group" />
        <FormControlLabel value="4" control={<Radio />} label="Prenatal" />
		
		<FormControlLabel value="5" control={<Radio />} label="Product" />
		<FormControlLabel value="6" control={<Radio />} label="Personal Training online" />
		<FormControlLabel value="7" control={<Radio />} label="TTC" />
      </RadioGroup>
    </FormControl>
</li>
 {this.state.classtype === "3" && (<React.Fragment>
    <li>
      <FormControlLabel
  control={
    <Checkbox
      checked={this.state.or_isenablebranch}
      onChange={this.handleAllBranchChange}
      color="primary"
    />
  }
  label="Do you opt for all branches?"
/>

    </li>
 </React.Fragment> )}

{(this.state.classtype!=="1"  ) && (
<React.Fragment>
{this.state.Branchdata.length>1 && (
<li>
<p>Select Branch</p>

<p>
<FormControl  >			   
			<Select
			 className="txtbox"
			native
			value={this.state.brid}
			onChange={this.myChangeHandler}
			name='brid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
)}
</React.Fragment>
)}
{this.state.ortype===false && (<React.Fragment>
{this.state.classtype!=="5" && (
<li>
<p>Select Duration</p>
<p><FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.subid}
			onChange={this.myChangeHandler}
			name='subid'
			
			fullwidth
			
			
			>
		
		
			{this.state.subscribeData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl></p>
 
 <p>Discount</p>
 
 <p> <TextField id="ordclsdiscount" name="ordclsdiscount"  variant="outlined"  
            fullWidth  className="signinpt" 
			value={this.state.ordclsdiscount}  onChange={this.myChangeHandler}/> </p>
</li>
)}



</React.Fragment>

)}

{this.state.ortype===false && (<React.Fragment>
{( this.state.classtype==="4" || this.state.classtype==="7") && (
<li>
<p>Select Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.slotid}
			onChange={this.myChangeHandler}
			name='slotid'
			
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
)}
</React.Fragment>
)}
 
{this.state.ortype===false && (<React.Fragment>
{(this.state.classtype!=="5" ) && (
<li><p>Start Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.startdate) }
className="txtbox"  
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>

</li>

)}
<li>
{/*<p>Price: Rs.{this.state.price}/- 

	{this.state.gstpercentage!==0  && (
	
	<React.Fragment>
	+{this.state.gstpercentage}% GST
	</React.Fragment>
	)}
</p>*/}
<b><p>
  Price: Rs.{parseFloat(this.state.price) + (this.state.or_isenablebranch ? parseFloat(this.state.or_extramt || 0) : 0)}/-

  {this.state.or_isenablebranch && this.state.or_extramt > 0 && (
    <React.Fragment> (incl. Rs.{this.state.or_extramt} extra)</React.Fragment>
  )}

  {this.state.gstpercentage !== 0 && (
    <React.Fragment> +{this.state.gstpercentage}% GST</React.Fragment>
  )}
</p></b>


</li><li>  
		  <p><span className="validation">*</span>Payment</p>
		 
		<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="role"
		   value={this.state.paymenttype}
		  name="paymenttype"
		inputProps={{tabIndex: "6"}}
        >
	<option value={0}>Select Payment</option>
	<option value={2}>Cash</option>
	<option value={3}>UPI</option>	
<option value={4}>Card</option>
        </Select>

		</FormControl>
		</p>
 
 </li>	</React.Fragment>)}
		  

</ul>
<div className="clear"></div>



{ (this.state.classtype==="1" && this.state.or_cu_id!=="") && ( <React.Fragment>

<div className="addressbox">
   
<p className="aligncentr">
<Button variant="text" variant="outlined" onClick={()=>{this.Categoryaddbox(1)}} className="simplebtn" startIcon={<MyLocationIcon  />}>Choose Your Location</Button>
</p>
{this.state.or_address !=="" && (
 <h4><b>Address:</b> {this.state.or_address}</h4>
)}
 </div>
 </React.Fragment>
 )}
 {(this.state.ortype===true && this.state.classtype!=="3") && (
 <ul className="Preferdays">
 <p><b>Select 3 Prefered  Days and Slot</b></p>
<li>
<p><span className="validate">*</span>Day</p>
<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native  className="txtbox"
		value={this.state.day1}
		onChange={this.myChangeHandler}
		name='day1'
		inputProps={{tabIndex: "2"}}
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={'Monday'}>Monday</option>
		<option value={'Tuesday'}>Tuesday</option>		
		<option value={'Wednesday'}>Wednesday</option>
<option value={'Thursday'}>Thursday</option>
		<option value={'Friday'}>Friday</option>		
		<option value={'Saturday'}>Saturday</option>	
	<option value={'Sunday'}>Sunday</option>			
		</Select>
		</FormControl>

</li>
<li>
<p><span className="validate">*</span> Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native inputProps={{tabIndex: "3"}}
			value={this.state.day1slot}
			onChange={this.myChangeHandler}
			name='day1slot'
			
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
<div className="clear"></div>
<li>
<p><span className="validate">*</span>Day</p>
<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native  className="txtbox"
		value={this.state.day2}
		onChange={this.myChangeHandler}
		name='day2'
		inputProps={{tabIndex: "4"}}
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={'Monday'}>Monday</option>
		<option value={'Tuesday'}>Tuesday</option>		
		<option value={'Wednesday'}>Wednesday</option>
<option value={'Thursday'}>Thursday</option>
		<option value={'Friday'}>Friday</option>		
		<option value={'Saturday'}>Saturday</option>	
	<option value={'Sunday'}>Sunday</option>			
		</Select>
		</FormControl>

</li>
<li>
<p> <span className="validate">*</span>Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.day2slot}
			onChange={this.myChangeHandler}
			name='day2slot'
			inputProps={{tabIndex: "5"}}
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
<div className="clear"></div>
<li>
<p><span className="validate">*</span>Day</p>
<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native  className="txtbox"
		value={this.state.day3}
		onChange={this.myChangeHandler}
		name='day3'
		inputProps={{tabIndex: "6"}}
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={'Monday'}>Monday</option>
		<option value={'Tuesday'}>Tuesday</option>		
		<option value={'Wednesday'}>Wednesday</option>
<option value={'Thursday'}>Thursday</option>
		<option value={'Friday'}>Friday</option>		
		<option value={'Saturday'}>Saturday</option>	
	<option value={'Sunday'}>Sunday</option>			
		</Select>
		</FormControl>

</li>
<li>
<p> <span className="validate">*</span>Slot</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native
			value={this.state.day3slot}
			onChange={this.myChangeHandler}
			name='day3slot'
			inputProps={{tabIndex: "7"}}
			fullwidth
			
			
			>
		
		
			{this.state.slotData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
</ul>

	)}
<div className="clear"></div>

 
 {this.state.ortype===false && (<React.Fragment>
{(this.state.classtype!=="3" && this.state.classtype!=="4" && this.state.classtype!=="7" && this.state.subid!==0 && localStorage.getItem("AYLbrid")!==null) && ( <React.Fragment>
<h4>Book your slots now</h4>


 <React.Fragment>
  <TableContainer className={useStyles.container}>  
  
 
                <Table className="boolsele">  
<TableHead> 

<TableRow>
                                              
     <TableCell></TableCell>                  
		 <TableCell>Mon</TableCell> 
 <TableCell>Tue</TableCell> 
 <TableCell>Wed</TableCell> 
 <TableCell>Thur</TableCell> 
 <TableCell>Fri</TableCell> 
 <TableCell>Sat</TableCell> 
  
                           </TableRow></TableHead>
					  
					   
                      <TableBody>
					  
                     {this.state.slotcalData.map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.sm_slotname}</TableCell>
<TableCell>

{item.ismonday==="0" && (
<CheckBoxOutlineBlankIcon onClick={()=>{this.handleAbsent(item.sm_id,index,1,1)}}/>
 
)}{item.ismonday==="1" && (

<img src={classelect} width="20px" onClick={()=>{this.handleAbsent(item.sm_id,index,1,2)}}/>

 
)}
{item.ismonday==="2" && (
<img src={clssblock} width="20px"/>
)}

</TableCell>
<TableCell>

{item.istuesday==="0" && (
<CheckBoxOutlineBlankIcon onClick={()=>{this.handleAbsent(item.sm_id,index,2,1)}}/>

)}{item.istuesday==="1" && (
<img src={classelect} width="20px" onClick={()=>{this.handleAbsent(item.sm_id,index,2,2)}}/>
 
)}{item.istuesday==="2" && (
<img src={clssblock} width="20px"/>
)}
</TableCell>

<TableCell>

{item.iswednesday==="0" && (

<CheckBoxOutlineBlankIcon  onClick={()=>{this.handleAbsent(item.sm_id,index,3,1)}}/>

)}{item.iswednesday==="1" && (
<img src={classelect} width="20px"  onClick={()=>{this.handleAbsent(item.sm_id,index,3,2)}}/>
 
)}{item.iswednesday==="2" && (
<img src={clssblock} width="20px"/>
)}
</TableCell>
<TableCell>

{item.isthursday==="0" && (
<CheckBoxOutlineBlankIcon onClick={()=>{this.handleAbsent(item.sm_id,index,4,1)}}/>

)}{item.isthursday==="1" && (
<img src={classelect} width="20px" onClick={()=>{this.handleAbsent(item.sm_id,index,4,2)}}/>

)}{item.isthursday==="2" && (
<img src={clssblock} width="20px"/>
)}
</TableCell>
<TableCell>

{item.isfriday==="0" && (
<CheckBoxOutlineBlankIcon onClick={()=>{this.handleAbsent(item.sm_id,index,5,1)}}/>

)}{item.isfriday==="1" && (
<img src={classelect} width="20px" onClick={()=>{this.handleAbsent(item.sm_id,index,5,2)}}/>
 
)}
{item.isfriday==="2" && (
<img src={clssblock} width="20px"/>
)}
</TableCell>
<TableCell>

{item.issaturday==="0" && (
<CheckBoxOutlineBlankIcon  onClick={()=>{this.handleAbsent(item.sm_id,index,6,1)}}/>
 
)}{item.issaturday==="1" && (
<img src={classelect} width="20px"  onClick={()=>{this.handleAbsent(item.sm_id,index,6,2)}}/>
 
)}{item.issaturday==="2" && (
<img src={clssblock} width="20px"/>
)}
</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.slotcalData.length===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="8">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer>
    </React.Fragment>

 

 <br/>
   </React.Fragment>
)}

</React.Fragment>
 )}
 {this.state.classtype==="5" &&(<React.Fragment>
 
 <Paper className={useStyles.root}>
 <TableContainer className={useStyles.container}>  
 <Table stickyHeader aria-label="sticky table"> 
 
 <TableHead> 
<TableRow>
  <TableCell width="25%"><b>Product Name</b></TableCell>     
  <TableCell width="10%"><b>Price</b></TableCell>  

 
  <TableCell width="10%"><b>Qty</b></TableCell>   

  <TableCell width="10%"><b>Amount</b></TableCell>    
   <TableCell> </TableCell> 
						
                      </TableRow></TableHead>

		   
               
                      <TableBody>
 {(this.state.pvdata).map((item,index) => {

stramount=parseFloat(item.amount)+parseFloat(stramount)

			
           return ( <React.Fragment>
		    {item.isdeleted!==1 && (	 
		   
		   <TableRow key={index} >



<TableCell>
	{this.state.showField!==item.op_id && (
<p>{item.title}</p>
)}	


 {this.state.showField===item.op_id && (
 
 
 <Autocomplete
      id="free-solo-demo"
      
       defaultValue={this.state.productselectdval}
		  inputValue={this.state.productselectdtags}
		   onInputChange={this.onInputprodChange}
      options={this.state.produserarray}
	   onChange={this.onTagsproductChange} 
	    value={this.state.selectedproduct}
      renderInput={(params) => (
        <TextField {...params} onChange={this.onloadProductsBind}  variant="outlined" />
      )}
      getOptionLabel={(option) => option.title || ""}
     renderOption={(props, option: AcOption) => (
        <React.Fragment>
		{option.rowindex!=="" &&(
          <table width='200%' >
            {option.rowindex=="1" &&(
          <thead>
          <tr>
         
            <th width='10%'> Name</th>
			  <th width='10%'>Price</th>
			   <th width='10%'>Offer Price</th>
			   
				  </tr> 
        </thead>)}
            <tbody>
              <tr {...props}>
               
                <td width='10%'>{option.title}</td>
				
                <td width='10%'>{option.pr_price}</td>
				<td width='10%'>{option.pr_offerprice}</td>
				
              </tr>
            </tbody>
          </table>
		  )}
        </React.Fragment>
      )}
    />
 
 
 
 )}   		   
	</TableCell>
	
<TableCell>
{this.state.showField!==item.op_id && (


<p>{item.price}</p>

)}
 {this.state.showField===item.op_id && (
 < TextField
            variant="outlined"
            margin="normal"
           
            fullWidth
			value={item.price}
            id="qty"
           
			inputRef={element => (this.textRef = element)}
            name="price"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength: 5
  }}
			
		 />


 )}
</TableCell>
	

<TableCell>
{this.state.showField!==item.op_id && (


<p>{item.qty}</p>

)}
 {this.state.showField===item.op_id && (
 < TextField
            variant="outlined"
            margin="normal"
           
            fullWidth
			value={item.qty}
            id="qty"
           
			inputRef={element => (this.textRef = element)}
            name="qty"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength: 5
  }}
			
		 />


 )}
</TableCell>

<TableCell>
 


 


<p>{item.amount}</p>



</TableCell> 

{this.state.showField===item.op_id && (

<TableCell align="right"> 


<Tooltip title="Save">
 <IconButton aria-label="Save">
<div className="addbtns">
<AddIcon onClick={()=>{this.fieldsave(item.op_id,"1")}} />
</div>
 </IconButton>
 </Tooltip>
 
 
</TableCell> 
)}









{this.state.showField!==item.op_id && (	
<TableCell align="right">


{item.f !=="-1" &&(
<React.Fragment>


<Tooltip title="Edit">
 <IconButton aria-label="Edit">
<div className="primary">
 <EditIcon onClick={this.fieldedit.bind(this, item.op_id,item.prid)} />
 </div>
 </IconButton>
 </Tooltip>
 
 
 </React.Fragment>  
  )}
 

 <Tooltip title="Delete">
 <IconButton aria-label="Delete">
  <div className="secondary">
 <DeleteIcon onClick={()=>{this.fieldsave(item.op_id,"2")}}/>
 </div>
 </IconButton>
 </Tooltip>
 

 </TableCell>
)}
		</TableRow>   
			)}
		    </React.Fragment>)
 })}
 
 <TableRow>   
 <TableCell colspan="3">
 Sub Total
  </TableCell>
   <TableCell colspan="3">
{this.state.subtotal}
  </TableCell>
 </TableRow> 
  
 <TableRow>   
 <TableCell colspan="3">
 GST
  </TableCell>
   <TableCell colspan="3">
  {this.state.ordgst}
  </TableCell>
 </TableRow>
<TableRow>   
 <TableCell colspan="3">
Discount
  </TableCell>
   <TableCell colspan="3">
 <TextField
            variant="outlined"
            margin="normal"           
            
			    type="number"
            name="orddiscount" 
			  onChange={this.myChangeHandler}
	 value={this.state.orddiscount}
   
      
			
          />
  </TableCell>
 </TableRow> 
 <TableRow>   
 <TableCell colspan="3">
 Grand Total
  </TableCell>
   <TableCell colspan="3">
  {this.state.grandtotal}
  </TableCell>
 </TableRow>  
 </TableBody></Table>
  </TableContainer> 
  </Paper>
		   </React.Fragment>
 )}
 

 <p> Billing Address</p>
<p>
 <TextField id="biladrs" name="biladrs"  variant="outlined" multiline 
            fullWidth  className="signinpt" rows="3"
			value={this.state.biladrs}  onChange={this.myChangeHandler}/> 
			</p>
<p className="aligncentr">
<Button
            type="submit"
            halfWidth
			disabled={this.state.btndisabled}
            variant="contained" 
           className="btnmainbg"
           id="btnLogin"  
		onClick={this.OnclickSubscribe}
           
          >
           {this.state.btnsubmitext} 
          </Button>
</p>
</div></div></div>


<div className="clear"></div>
		</React.Fragment>
	)
	}	
}


export  class  Customerbox extends Component {
	
	 constructor(props) {
      super(props)
	  
      this.state = {open:false,erropen:false,errormessage:'',cuname:'',cuemail:'',cuphone:'',cupassword:'',cuid:'',alerttp:"error",hide:false,showPassword:false}
	 }
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
	myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="cuphone")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	   }
  }
  else{
  this.setState({[nam]: val});
  }
}
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
handleClose = (e) => {
	
	const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

 let cuname = this.state.cuname;
 let cuemail = this.state.cuemail;
 let cuphone = this.state.cuphone;
  let cupassword = this.state.cupassword;
 
 if(cuname==="")
{
	this.setState({errormessage:"Please Enter Name",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
	
}
 if(cuemail!=="")
{

	
	 if (!remail.test(cuemail)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});
		 window.scrollTo({        top: 0     })
	return false; 
  }
}
if(cuphone==="")
{
	this.setState({errormessage:"Please Enter Phoneno.",erropen:true});
	return false;
} 
if(cupassword==="")
{
	this.setState({errormessage:"Please Enter Password.",erropen:true});
	return false;
}
this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  
	 if(this.state.cuid!=="")
	 {
	  
	  formData.append('cu_id',this.state.cuid)
	 }else
	 {
		formData.append('cu_id',0)  
	 }
	 formData.append('action','insertorupdate')
    formData.append('cu_name',cuname)
	 formData.append('cu_emailid',cuemail)
	 formData.append('cu_password',cupassword)
		   formData.append('cu_phoneno',cuphone)
		    let search = window.location.href;
 let ldmid = this.getParameterByName('ldid',search);
	if(ldmid!==null)
	{ 
	  		 formData.append('leadid',ldmid)
	}
	  formData.append('userid',localStorage.getItem("AYLuserid"))
	  
	 axios.post(Serverurl+"ajaxcustomer.php", formData, {
        }).then(res => {
				if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Customer Already Exist.",erropen:true,open:true,btndisabled:false,alerttp:"info",
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
		this.setState({ open:false });	
						  
	this.props.parentCallback(res.data); 
  }
    }); 
}
  handleClickNewShowPassword = () => {
    
	this.setState({
            showPassword: !this.state.showPassword
          })
  };
	
	  handleMouseDownPassword = event => {
    event.preventDefault();
  };
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open, cuname:'',cuemail:'',cuphone:'',cupassword:'',
	  });
		 let search = window.location.href;
	 let ldimd = this.getParameterByName('ldid',search);
	if(ldimd!==null)
	{  
this.Leadmastergetdata(ldimd);

	}
		
};
Leadmastergetdata(ldimd) {
	
   axios.get(Serverurl+'ajaxleadmaster.php?action=getall&ldm_id='+ldimd)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({cuname:resp.data[0].ldm_firstname,cuemail:resp.data[0].ldm_emailid,cuphone: resp.data[0].ldm_phoneno,hide:true });
	}
  });
}
render (){

return(
<React.Fragment>
  <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Add Customer</DialogTitle>
      <DialogContent>
	  


	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttp}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
	  <p><span className="validation">*</span>Name</p>
		 
		<p>
		<TextField name="cuname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cuname}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
			<p>Email Id:</p>
		<p> <TextField name="cuemail" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cuemail}
			 
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
<p > <span className="validation">*</span>Phone No. : </p>
		  
		  <p > 
		  
		  
		 <TextField name="cuphone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cuphone}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "3",maxLength:10}} className="txtbox" 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>
  <p ><span className="validation">*</span>Password : </p>
		  
		  <p> 
		  
		  <FormControl fullWidth  variant="outlined">
 
          <OutlinedInput value={this.state.cupassword}
            id="cupassword" name="cupassword" 
			
			type={this.state.showPassword ? 'text' : 'password'}
            onChange={this.myChangeHandler}
			inputProps={{tabIndex: "2",maxLength:15}} InputLabelProps={{ shrink: true }}  
			size="small"
            endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickNewShowPassword}
                  onMouseDown={this.handleMouseDownPassword1}  >
				  { this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
           />
         
        </FormControl>
		 
		  
		 
		  </p>
		  
		         <div className="actionbtns">
				
	   <div className="cancelbtn">	  
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
				 
				 </div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
   Save
</Button>
  </div>     


	
<div className="clear"></div>

 </div>
		  
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 